// extracted by mini-css-extract-plugin
export var footer = "_n8-5";
export var fulfillmentInput = "_n8-0";
export var shipDateInput = "_n8-1";
export var shipmentModal = "_n8-2";
export var shipmentModalContent = "_n8-3";
export var tableContainer = "_n8-4";